import { Action } from '@ngrx/store';
import * as authentication from '../../actions/data/authentication';
import * as stageTypes from '../../../stage/types';
import * as commonTypes from '../../../shared/types';

//beacon
import { createMetaReducer } from 'redux-beacon';
import {
  GoogleAnalytics,
  PageView,
  Event,
  Exception
} from 'redux-beacon/targets/google-analytics';

// import { logger } from 'redux-beacon/extensions/logger'; // if need to log to console

// Map the event to an ngrx/store action
const eventsMap = {
    '[Data Stage] Get Stage Data Success': (action: Action): Event => ({
        hitType: 'event',
        eventCategory: 'Stage',
        eventAction: 'Name',
        eventLabel:  (<stageTypes.IStageResponse>action.payload).name
    }),
    '[Data Stage] Select to navigate to a Page Success': (action: Action): Event => ({
        hitType: 'event',
        eventCategory: 'Stage',
        eventAction: 'Page',
        eventLabel: (<commonTypes.IPageInfo>action.payload).name
    })
};

// Create the meta Reducer
export const analyticsStageMetaReducer = createMetaReducer(eventsMap, GoogleAnalytics);



// WEBPACK FOOTER //
// ./src/app/stateManagement/reducers/metaReducer/stage.metaReducer.ts